import React, { useState, useEffect, useRef } from "react";
import { useStoreon } from "storeon/react";
import styles from "./styles.module.scss";
import { withTranslation } from "react-i18next";
import img from "../../shared/images/settings-background.jpg";
import {
  getUsers,
  updateUser,
  createUser,
  deleteUser,
  sendVerificationCode,
} from "../../services/usersService";
import InfiniteScroll from "react-infinite-scroll-component";
import UserCard from "../components/userCard/userCard";
import themeStyles from "../../shared/styles/theme/theme-styles.module.scss";
import InputGroup from "../components/inputGroup/InputGroup";
import UserAdmin from "./userBox/userAdmin";
import Modal from "../components/modal/modal";
import { success, error } from "../components/toast/toast";
import { useHistory } from "react-router-dom";
import { LOGOUT } from "../../store/auth";

const Users = (props) => {
  const { auth, dispatch } = useStoreon("auth");
  const [usersList, setUsersList] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const mounted = useRef(false);
  const [search, setSearch] = useState(null);
  const [usersFiltered, setUsersFiltered] = useState(usersList);
  const [showForm, setShowForm] = useState(null);
  const [userSelected, setUserSelected] = useState({});
  const [status, setStatus] = useState("");
  const history = useHistory();

  useEffect(() => {
    if (!mounted.current) {
      getUsers(auth, page)
        .then((res) => {
          if (res.success === false && res.message === "Not Valid Token") {
            history.push("/login");
          } else if (res.success === false) {
            error(res.message, { onClose: () => {} });
            dispatch(LOGOUT);
            history.push("/login");
          } else {
            setUsersList(res.data);
            setTotalPages(res.total_pages);
            setUsersFiltered(res.data);
          }

          mounted.current = true;
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  }, [page]);

  useEffect(() => {
    setUsersFiltered(usersList);
  }, [usersList]);

  const fetchMoreData = () => {
    if (page === totalPages) {
      setHasMore(false);
      return;
    }
    getUsers(auth, page + 1).then((res) => {
      setUsersList(usersList.concat(res.data));
      setPage(res.page);
    });
  };

  const handleChange = (e) => {
    setSearch(e.target.value);
    const temp = usersList.filter((row) => {
      return Object.keys(row).reduce(
        (acc, value) =>
          !acc
            ? String(row[value])
                .toLowerCase()
                .includes(e.target.value.toLowerCase())
            : acc,
        false
      );
    });
    setUsersFiltered(temp);
  };

  const changeStatus = (status) => {
    setStatus(status);
    setShowForm(status);
  };

  const selectUser = (id) => {
    setUserSelected(usersList.find((e) => e.id === id));
  };

  const handleDelete = () => {
    deleteUser(auth, userSelected.id).then((res) => {
      if (res.success !== false) {
        setShowForm(null);
        success("Account successfully deleted", { onClose: () => {} });
        getUsers(auth, 1).then((res) => setUsersList(res.data));
      }
    });
  };

  const handleSubmit = (values, status) => {
    if (status === "edit") {
      return updateUser(auth, values, userSelected.id).then((res) => {
        if (res.success !== false) {
          setShowForm(null);
          success("Account successfully updated", { onClose: () => {} });
          getUsers(auth, 1).then((res) => setUsersList(res.data));
        } else {
          if (res.message && res.message === "duplicated entry") {
            error("Provided email is already taken.", { onClose: () => {} });
          }

          if (
            res.message &&
            typeof res.message !== "string" &&
            res.message.length
          ) {
            res.message.forEach((message) => {
              error(message, { onClose: () => {} });
            });
          }
        }
        return res;
      });
    }
    return createUser(auth, values).then((res) => {
      if (res.success !== false) {
        setShowForm(null);
        getUsers(auth, 1).then((res) => setUsersList(res.data));
        success(
          "Account created. An email has been sent to the user to verify the account.",
          { onClose: () => {} }
        );
      } else {
        if (res.message && res.message === "duplicated entry") {
          error("Provided email is already taken.", { onClose: () => {} });
        }

        if (
          res.message &&
          typeof res.message !== "string" &&
          res.message.length
        ) {
          res.message.forEach((message) => {
            error(message, { onClose: () => {} });
          });
        }
      }
      return res;
    });
  };

  const header = {
    id: "ID",
    name: "First Name",
    last_name: "Last Name",
    email: "Email",
    role: "Role",
    accountType: "Account Type",
    is_verified: "Verification",
  };

  const onSendCodeHandler = (user) => {
    sendVerificationCode(auth, user.id).then((res) => {
      if (res.success !== false) {
        success("Sent Code", { onClose: () => {} });
      }
    });
  };

  return (
    <div className={styles.overallContainer}>
      <div className={styles.lines}></div>
      <div className={styles.bodyContainer}>
        <div className={styles.search}>
          <div className={styles.inputSearch}>
            <InputGroup
              name="search"
              placeholder="Search User"
              inputValue={search}
              onChange={handleChange}
            />
            <i className={themeStyles.iconSearch} />
          </div>
          <button
            className={`${themeStyles.btnPrimaryLT} ${styles.btnAdd}`}
            onClick={() => changeStatus("add")}
          >
            Add New User
          </button>
        </div>
        <UserCard user={header} header />
        <InfiniteScroll
          dataLength={usersList && usersList.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={
            <h4 style={{ textAlign: "center", color: "white" }}>Loading...</h4>
          }
          style={{ overflow: "visible" }}
        >
          {usersFiltered.map((user, index) => (
            <UserCard
              user={user}
              key={`${user.id}--${index}`}
              selectUser={selectUser}
              changeStatus={changeStatus}
              sendCode={onSendCodeHandler}
            />
          ))}
        </InfiniteScroll>
      </div>
      {showForm && (
        <Modal
          width={status === "delete" ? 543 : 727}
          className={`${styles.userModal} ${
            status === "delete" ? styles.userModalDelete : ""
          }`}
        >
          <UserAdmin
            handleSubmit={handleSubmit}
            handleDelete={handleDelete}
            changeStatus={changeStatus}
            formStatus={showForm}
            userSelected={showForm === "add" ? {} : userSelected}
            t={props.t}
          />
        </Modal>
      )}
      <div
        className={styles.backgroundImage}
        style={{
          backgroundImage: `url(${img})`,
        }}
      />
    </div>
  );
};

export default withTranslation("common")(Users);
